import { render, staticRenderFns } from "./OnlineBank.vue?vue&type=template&id=327fe1a4"
import script from "./OnlineBank.vue?vue&type=script&lang=js"
export * from "./OnlineBank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports